import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './LoadingDots.module.scss';
import { ColorVariantType } from '../../../../types';


interface LoadingDotsProps {
  variant?: ColorVariantType["variant"] | 'white' | 'black',
  size?: "md" | "lg" | "xl",
};

const DOTS_CLASS = {
  variant: {
    default: "tw-bg-gray-500",
    primary: "tw-bg-primary-500",
    secondary: "tw-bg-secondary-500",
    info: "tw-bg-blue-500",
    success: "tw-bg-green-500",
    warning: "tw-bg-yellow-500",
    danger: "tw-bg-red-500",
    white: "tw-bg-white",
    black: "tw-bg-black"
  }
}

const LoadingDots: React.FC<LoadingDotsProps> = ({ size = "md", variant = "default" }) => {
  return <span className={styles.loading}>
    {Array.from(Array(3)).map((n, i) => {
      return <span key={`loading_dots_${i}`} className={classNames(styles[size], DOTS_CLASS.variant[variant])} />
    })}
  </span>;
};


LoadingDots.propTypes = {
  variant: PropTypes.oneOf(["default", "primary", "success", "info", "warning", "danger", "white", "black"]),
  size: PropTypes.oneOf(["md", "lg", "xl"])
};

export default LoadingDots;
